import { AppStateType } from '../reducers'

export const selectServerConfig = ({ serverConfig }: AppStateType) =>
  serverConfig

export const selectAllowedDomains = ({ serverConfig }: AppStateType) =>
  serverConfig.allowedDomains
